<template>
  <row-action
    icon="EditIcon"
    :label="label || $t('foundation.rowEdit')"
    :danger="false"
  />
</template>

<script>
import RowAction from '@/components/foundation/RowAction.vue'

export default {
  name: 'EditRow',
  components: { RowAction },
  props: { label: { type: String, default: '' } },
}
</script>
